import { useMemo } from 'react';

import { buildNavMenus, type NavMenu } from './nav-menu';

import { useFilterOptions } from '@/features/search/api';

/**
 * The header's mega-menu, built from live `/filter-options` data.
 *
 * Shares the `['filter-options']` query with the search filter panel, so the
 * header adds no extra request — whichever mounts first populates the cache for
 * the other. While the query is loading (or if it failed) this returns the menu
 * with only its non-API groups, never placeholder taxonomy.
 */
export function useNavMenus(): NavMenu[] {
  const { data } = useFilterOptions();
  return useMemo(() => buildNavMenus(data), [data]);
}
